<p-panel [toggleable]="true" [collapsed]="false">
  <ng-template #header>
    <div class="flex items-center justify-between gap-2 font-bold text-lg w-full">
      <div class="flex items-center gap-2">
        <span>{{ providerName() }}</span>
        <span class="text-gray-400">|</span>
        <span>{{ toolName() }}</span>
      </div>
      <span
        class="px-2 py-1 rounded-sm border text-xs font-semibold mr-24"
        [ngClass]="{
          'text-green-400 border-green-400': overallScore().overall >= getThresholdScore(3),
          'text-yellow-400 border-yellow-400':
            overallScore().overall >= getThresholdScore(2) &&
            overallScore().overall < getThresholdScore(3),
          'text-red-400 border-red-400': overallScore().overall < getThresholdScore(2),
        }"
      >
        Overall score: {{ overallScore().overall | appNumber: '1.1-1' }} ({{
          overallScore().percent | appNumber: '1.0-0'
        }}%)
      </span>
    </div>
  </ng-template>
  <ng-template #headericons let-collapsed>
    <i class="pi" [ngClass]="collapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
  </ng-template>

  <app-evaluation-matrix
    [tool]="tool()"
    [data]="data()"
    [selectedUserId]="selectedUserId()"
    [averageMode]="averageMode()"
    [averageUserIds]="averageUserIds()"
    [currentUserId]="currentUserId()"
    [readOnly]="readOnly()"
    (ratingChange)="onRatingChange($event)"
    (commentOpen)="onCommentOpen($event)"
  >
  </app-evaluation-matrix>

  @if (changedRatings().length > 0 && !readOnly()) {
    <div class="flex justify-end mt-2">
      <app-project-step-save-button
        [disabled]="readOnly()"
        (clicked)="save()"
      ></app-project-step-save-button>
    </div>
  }
</p-panel>
